import React, { useState, useEffect, useRef } from 'react'
import { useParams } from "react-router-dom";
import { get } from '../../../../util/AcessoApi'
import ReactToPrint from 'react-to-print';
import { meses } from '../../../../util/Utilitarios';
import { Imprimir } from '../../../../components/Acoes';
import { TIPO_PERGUNTA } from '../../../../util/Enums';
import '../../consultaPreAnestesico/css/formulario.css';
import { ReservaRodapeHash, RodapeHash } from '../../../../components/RodapeHash';

const Campo = ({ label, valor, flex }) => (
    <div className="text-container" style={{ flex: flex || 1 }}>
        <span className="label"><b>{label}: </b></span>
        <span className="underline">{valor || ''}</span>
    </div>
)

// Conteúdo impresso da ficha pós-anestésica: usado nesta tela e na impressão da guia com os indicadores
const FichaPosImpressao = ({ ficha }) => (
    <div className="form-container">
        <div className='row'>
            <div className='col-6'>
                <div><img className='logo-ficha' src={require('../../../../assets/img/cropped-logo-equipe.png')} /></div>
                <div className="header">Ficha de Indicadores Assistenciais</div>
                <div className="text-container data-consulta" style={{ flex: 1 }}>
                    <span className="label"><b>Data: </b></span>
                    <span className="underline">{ficha?.data_registro_formatada || ''}</span>
                </div>
            </div>
            <div className='col-6'>
                <div className='dados-paciente'>
                    <div className='p-1'>
                        <div className="dados-paciente-label">
                            <Campo label='Atendimento' valor={ficha?.atendimento?.label} />
                        </div>
                        <div className='dados-paciente-label flex-row'>
                            <Campo label='Data Nascimento' valor={ficha?.data_nascimento} flex={2} />
                            <Campo label='Idade' valor={ficha?.idade} />
                            <Campo label='Sexo' valor={ficha?.sexo} />
                        </div>
                        <div className="dados-paciente-label">
                            <Campo label='Operadora de Saúde' valor={ficha?.operadora_saude?.label} />
                        </div>
                        <div className="dados-paciente-label">
                            <Campo label='Estabelecimento de Saúde' valor={ficha?.estabelecimento_saude?.label} />
                        </div>
                        <div className="dados-paciente-label">
                            <Campo label='Data do Procedimento' valor={ficha?.data_procedimento} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='form-table'>
            <div className='info' style={{ flex: 1 }}>
                <div className='value'>
                    <div className='question-container'>
                        {
                            ficha?.agrupamentos ? ficha.agrupamentos.map((agrupamento) => {
                                return <React.Fragment key={agrupamento.id}>
                                    <div className='title'>
                                        {agrupamento.descricao}
                                    </div>
                                    {
                                        agrupamento.questoes ? agrupamento.questoes.map((questao) => {
                                            let ajustarOpcoes = false;

                                            if (questao.tipo_pergunta != TIPO_PERGUNTA.COMENTARIO) {
                                                const arrOp3Caracteres = questao?.opcoes?.filter(x => x.descricao.length <= 3) || [];
                                                ajustarOpcoes = arrOp3Caracteres.length == questao?.opcoes?.length || questao?.opcoes?.length <= 3;
                                            }

                                            return <div key={questao.id} className='text-left p-1 question'>
                                                <div className='row-space-between'>
                                                    <span className='fs-13 mb-1'>{questao.descricao}</span>
                                                    {questao.mostrar_nao_possui ? <div className="no-wrap checkbox-container">
                                                        <div className={`checkbox ${questao.nao_possui ? 'checked' : ''}`}></div>
                                                        <span>Negativo</span>
                                                    </div> : <></>}
                                                </div>

                                                {questao.tipo_pergunta == TIPO_PERGUNTA.COMENTARIO ?
                                                    <div className='textarea'><span className='span-obs'>{questao.observacao}</span></div>
                                                    : <>
                                                        <div className='options-form' style={ajustarOpcoes ? { gridTemplateColumns: questao?.opcoes?.length >= 5 ? 'repeat(5, 1fr)' : `repeat(${questao?.opcoes?.length}, 1fr)` } : {}}>
                                                            {
                                                                questao?.opcoes ? questao.opcoes.map((opcao) => {
                                                                    return <div key={opcao.id} className="checkbox-container">
                                                                        <div className={`checkbox ${opcao.marcado ? 'checked' : ''}`}></div>
                                                                        <span>{opcao.descricao}</span>
                                                                    </div>
                                                                }) : <></>
                                                            }
                                                        </div>
                                                        <div className='div-span-obs'>
                                                            <span className='span-obs'>{questao.observacao || ""}</span>
                                                        </div>
                                                    </>}
                                            </div>
                                        }) : <></>
                                    }
                                </React.Fragment>
                            }) : <></>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div className='mt-2'>
            <div className='cartao-assinatura'>
                <div className='ca-esq'>ANESTESIOLOGISTA</div>
                <div className='ca-meio'>
                    <b>{(ficha?.anestesiologista_nome || ficha?.anestesiologista || '').toUpperCase()}</b>
                    {ficha?.anestesiologista_crm ? <span>CRM {ficha.anestesiologista_crm}</span> : <></>}
                    <small>VERIFICADO DIGITALMENTE</small>
                </div>
                <div className='ca-dir'>{ficha?.data_procedimento || ''}</div>
            </div>
        </div>
    </div>
)

const Visualizacao = (props) => {
    const reference = useRef();
    const btnPrint = useRef();
    const actualDate = new Date();
    const [ficha, setFicha] = useState({})
    let { id } = useParams()

    useEffect(_ => {
        Promise.resolve(get(`/posanestesico/consultaposanestesico/${id || 0}`)).then(obj => {
            setFicha(obj || {})
        })
    }, [id])

    return <div ref={reference}>
        <RodapeHash hash={ficha.hash_impressao} />
        <ReservaRodapeHash hash={ficha.hash_impressao}>
        <div className="card">
        <ReactToPrint
            trigger={() => <button className={"hidden d-none"} ref={btnPrint} />}
            content={() => reference.current} pageStyle={`@page { size: ${props.orientacao || 'a4 auto'} }`} />
        <div className="card-body">
            <div className={'d-none-print colored'}>
                <div className={'col-12 row mr-0 ml-0 mb-1 pr-0 pl-0'}>
                    <div className="col-12 row-space-between pr-0 pl-0">
                        <div>
                        </div>
                        <div className="text-right">
                            <Imprimir action={() => btnPrint.current.click()} />
                        </div>
                    </div>
                    <div className="col-12 titulo-visualizacao">
                        <h5>{'Ficha'}</h5>
                        <h6>{actualDate.getDate().toString().padStart(2, '0') + ' de ' + (meses[actualDate.getMonth() + 1] || meses.default) + ' de ' + actualDate.getFullYear()}</h6>
                    </div>
                </div>
            </div>
            <FichaPosImpressao ficha={ficha} />
        </div>
        </div>
        </ReservaRodapeHash>
    </div>
}

export { FichaPosImpressao }
export default Visualizacao
